import { ref, readonly } from 'vue'

export const ALERT_TYPES = {
  NOTICE: '',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
} as const

export type AlertID = number
export type AlertType = ValueOf<typeof ALERT_TYPES>
export type AlertItem = {
  id: AlertID
  message: string
  type: AlertType
}

export const useAlertStore = () => {
  const items = ref<AlertItem[]>([])
  const latestId = ref<AlertID>(0)

  const push = (message: string, type: AlertType): AlertItem => {
    latestId.value = latestId.value + 1
    const newItem: AlertItem = {
      id: latestId.value,
      message,
      type,
    }
    items.value = [...items.value, newItem]
    return newItem
  }

  const remove = (id: AlertID): void => {
    items.value = items.value.filter(item => item.id !== id)
  }

  const clear = (): void => {
    items.value = []
  }

  return {
    items: readonly(items),
    latestId: readonly(latestId),
    push,
    remove,
    clear,
  }
}

export type AlertStore = ReturnType<typeof useAlertStore>
